import { render, staticRenderFns } from "./ProductBatch.vue?vue&type=template&id=3d607a1c&"
import script from "./ProductBatch.vue?vue&type=script&lang=js&"
export * from "./ProductBatch.vue?vue&type=script&lang=js&"
import style0 from "./ProductBatch.vue?vue&type=style&index=0&id=3d607a1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports